import { IMAGES } from "../assets/media/images";

export function getCardImage(rare) {
    if (rare === "Обычная") {
        return IMAGES.common
    } else if (rare === "Редкая") {
        return IMAGES.rare
    } else if (rare === "Эпическая") {
        return IMAGES.epic
    } else if (rare === "Легендарная") {
        return IMAGES.legendary
    } else if (rare === "Мифическая") {
        return IMAGES.mythical_puzzle
    }
};

export function getCardRare(rare) {
    if (rare === "Обычная") {
        return "common"
    } else if (rare === "Редкая") {
        return "rare"
    } else if (rare === "Эпическая") {
        return "epic"
    } else if (rare === "Легендарная") {
        return "legendary"
    } else if (rare === "Мифическая") {
        return "mythical"
    }
};

export function getCardColor(rare) {
    if (rare === "Обычная") {
        return "var(--green-color)";
    } else if (rare === "Редкая") {
        return "var(--blue-color)"
    } else if (rare === "Эпическая") {
        return "var(--orange-color)"
    } else if (rare === "Легендарная") {
        return "var(--purple-color)"
    } else if (rare === "Мифическая") {
        return "var(--aqua-color)"
    }
};